<template>
  <div class="notice-sign min-height padding">
    <div class="flex align-center justify-between margin-bottom">
      <div class="flex align-center">
        <el-input placeholder="请输入机构名称" v-model="searchName"></el-input>
        <el-button type="primary" class="margin-left-sm" @click="search"
          >搜索</el-button
        >
      </div>
      <div class="flex align-center">
        <span class="font-size-lg">已报名：{{ signUp_num }} </span>
        <i class="padding-left"></i>
        <span class="font-size-lg"> 已签到：{{ signIn_num }}</span>
        <el-button
          v-if="user.user_role === 1"
          class="margin-left"
          type="primary"
          @click="sginDialag = true"
        >
          添加报名信息
        </el-button>
        <el-link
          
          :underline="false"
          class=" margin-left-sm"
          :href="udhost + '/api/Operation/notice_export?notice_id=' + id"
          target="_blank"
        >
          <el-button class="margin-left" type="primary">
            报名信息导出
          </el-button>
        </el-link>
      </div>
    </div>
    <el-table
      :data="tableData"
      header-row-class-name="table-header"
      row-class-name="table-row"
      alig="center"
      border
      style="width: 100%"
    >
      <el-table-column type="index" label="序号" width="50"> </el-table-column>
      <el-table-column prop="company_name" label="企业全称" width="220">
      </el-table-column>
      <el-table-column prop="tel_name" label="联系人"> </el-table-column>
      <el-table-column prop="tel_number" width="160" label="联系人手机号">
      </el-table-column>
      <el-table-column prop="create_time" width="160" label="报名时间">
      </el-table-column>
      <el-table-column prop="signin_time" width="160" label="签到时间">
        <template slot-scope="scope">
          {{ scope.row.is_signin === 0 ? "" : scope.row.signin_time }}
        </template>
      </el-table-column>
      <el-table-column prop="state" width="100" label="类型">
        <template slot-scope="scope">
          {{ scope.row.state === 0 ? "非会员单位" : "会员单位" }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150px">
        <template slot-scope="scope">
          <!-- <el-button
            type="text"
            class="font-size-sm"
            @click="toDetail(scope.row)"
          >
            查看报名信息
          </el-button> -->
          <el-button
            type="text"
            class="font-size-sm"
            @click="toEdit(scope.row)"
          >
            {{ user.user_role === 1 ? "查看/编辑" : "查看" }}
          </el-button>
          <el-button
            v-if="user.user_role === 1"
            type="text"
            class="font-size-sm"
            @click="delItem(scope.row.id)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="tableData.length > 0"
      class="page-all"
      background
      @current-change="getList"
      :current-page.sync="page"
      :page-size="limit"
      layout="prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <sign-edit
      :setItem="setItem"
      :sginDialag="sginDialag"
      @cancelDialog="cancelDialog"
    />
  </div>
</template>

<script>
import { UDHOST } from "@/config";
import signEdit from '@/views/admin/children/signEdit'
import { noticeSignUpQueryManage, noticeSignInDelManage } from '@/api/admin'
export default {
  name: "noticeSign",
  data () {
    return {
      id:'',
      searchName: '',
      page: 1,
      limit: 10,
      total: 0,
      tableData: [],
      signIn_num: 0,
      signUp_num: 0,
      sginDialag: false,
      setItem: null,
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    udhost () {
      return UDHOST
    },
  },
  created () {
    this.id = this.$route.params.id
    this.$emit("setIndex", '/admin/noticeDetail', "通知公告  /  报名信息", true, 'icon-gonggao');
    this.getList()
  },
  components: { signEdit },
  methods: {
    toEdit (obj) {
      this.setItem = obj
      this.sginDialag = true
    },
    cancelDialog (val) {
      if (val) {
        this.getList()
      }
      this.setItem = null
      this.sginDialag = false
    },
    //  删除报名
    delItem (id) {
      this.$confirm('此操作将删除该报名信息, 是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.sureDelete(id)
      })
    },
    async sureDelete (id) {
      let _state = await noticeSignInDelManage(id)
      if (_state.status === 200) this.$message.success(_state.msg), this.getList()
    },

    search () {
      this.page = 1
      this.getList()
    },
    //    获取列表
    async getList () {
      let _list = await noticeSignUpQueryManage(this.$route.params.id, this.searchName, this.page, this.limit)
      this.tableData = _list.data.list.data
      this.total = _list.data.list.total
      this.signIn_num = _list.data.info.signIn_num
      this.signUp_num = _list.data.info.signUp_num
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
</style>